/**
 * Labstep
 *
 * @module components/EntityStateWorkflow/SearchSelect/Option
 * @desc Component for rendering the search select option for the entity state workflow
 */

import {
  Action,
  EntityStateWorkflowActionMenu,
} from 'labstep-web/components/EntityStateWorkflow/Action/Menu';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { EntityStateWorkflowSearchSelectOptionProps } from './types';

export const EntityStateWorkflowSearchSelectOption: React.FC<
  EntityStateWorkflowSearchSelectOptionProps
> = ({ option, experimentWorkflow }) => (
  <div className={styles.groupOption}>
    {option.icon && <Icon name={option.icon} />}
    <div>
      <p className={styles.optionLabel}>{option.label}</p>
      <p className={styles.optionDescription}>{option.description}</p>
    </div>
    <div>
      {option.value !== 'entity' &&
        option.value !==
          experimentWorkflow.entity_state_workflow?.id && (
          <EntityStateWorkflowActionMenu
            entityStateWorkflow={option.entity}
            actions={[Action.view, Action.configure, Action.delete]}
          />
        )}
    </div>
  </div>
);
